import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Field from "../../../../Components/Field";
import MultiLineField from "../../../../Components/MultiLineField";
import Warning from "../../../../../../../Components/common/Warning/Warning";

import {
  requestGetMaliciousSubmissionMailContent,
  requestResetMaliciousSubmissionMailContent,
  requestSetMaliciousSubmissionMailContent,
} from "../../../../../../../store/actions/settingsActions";

const MailContents = () => {
  const dispatch = useDispatch();

  const mailContent = useSelector((state) => state.settings.mailContent);

  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [showResetWarning, setShowResetWarning] = useState(false);

  useEffect(() => {
    dispatch(requestGetMaliciousSubmissionMailContent());
  }, []);

  useEffect(() => {
    if (mailContent) {
      setEmailSubject(mailContent.mailSubject);
      setEmailBody(mailContent.mailBody);
    }
  }, [mailContent]);

  const maliciousSubmissionReporterContentReset = () => {
    setShowResetWarning(false);
    dispatch(requestResetMaliciousSubmissionMailContent());
  };

  const maliciousSubmissionReporterContentSave = () => {
    if (emailSubject && emailBody) {
      dispatch(
        requestSetMaliciousSubmissionMailContent({ subject: emailSubject, body: emailBody }),
      );
    } else {
      setError("Please fill in all the fields");
      setShow(true);
    }
  };

  useEffect(() => {});
  return (
    <div className="mailing__content__body">
      <div className="m-b-10">
        <Field
          label="Email Subject"
          onChange={(e) => setEmailSubject(e.target.value)}
          value={emailSubject}
          width="500px"
          parentClassName="m-b-10"
          tooltipText={
            "Special variables can be used in mail subject. For now just one variable is available: File Name. \n Reported file's name can be accessed via {{fileName}}"
          }
        />
        <MultiLineField
          label="Email Body"
          onChange={(e) => setEmailBody(e.target.value)}
          value={emailBody}
          width="500px"
          tooltipText={
            "Special variables can be used in mail body. For now just one variable is available: File Name. \n Reported file's name can be accessed via {{fileName}}"
          }
        />
      </div>
      <div className="flex flex-align-items-center m-b-10">
        <button className="m-r-15 default-button" onClick={() => setShowResetWarning(true)}>
          Default
        </button>
        <button className="primary-button" onClick={maliciousSubmissionReporterContentSave}>
          Save
        </button>
      </div>
      <Warning
        onClickOk={() => setShow(false)}
        show={show}
        setShow={setShow}
        text={error}
        article="Warning"
        cancelDisable={true}
        textOK="Okay"
      />
      <Warning
        onClickOk={maliciousSubmissionReporterContentReset}
        show={showResetWarning}
        setShow={setShowResetWarning}
        text="The email subject and body will be reset to their default content. Do you want to continue?"
        article="Reset"
      />
    </div>
  );
};

export default MailContents;
